class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }
  setupListeners() {
    let quantity = 1;
    const sum = document.querySelector(".setMore");
    const less = document.querySelector(".setLess");
    const spans = this.querySelectorAll(".qty-number");
    const input = document.querySelector(".setQtty");
    const minumum = this.querySelector(".red-text");

    input.addEventListener("input", () => {
      quantity = input.value;
      spans.forEach((span) => {
        span.innerText = quantity;
      });

      if (minumum) {
        if (Number(quantity) >= 100) {
          minumum.style.display = "none";
        } else {
          minumum.style.display = "block";
        }
      }
    });
    if (sum) {
      sum.addEventListener("click", () => {
        quantity = input.value;
        quantity = Number(quantity) + 1;
        spans.forEach((span) => {
          span.innerText = quantity;
        });
      });
    }
    if (less) {
      less.addEventListener("click", () => {
        quantity = input.value;

        if (quantity == 1) {
          quantity = 1;
        } else {
          quantity = quantity - 1;
        }
        spans.forEach((span) => {
          span.innerText = quantity;
        });
      });
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class PriceUpdater extends HTMLElement {
  connectedCallback() {
    setTimeout(() => {
      this.setupListeners();
    }, 1500);
  }
  setupListeners() {
    const input = document.querySelector(".setQtty");
    const cartButton = document.querySelector("#getCart");
    const text = this.querySelector(".isPRC");
    const data = this.querySelector("input");
    const price = data.value;
    const number = price.slice(1);

    const updatePrice = () => {
      const quantity = Number(input.value) || 0;
      text.innerText = `$${number * quantity}`;
      cartButton.disabled = quantity < 50;
    };

    input.addEventListener("input", updatePrice);
    input.addEventListener("propertychange", updatePrice);
    input.addEventListener("change", updatePrice);
    updatePrice();
  }
}

customElements.define("price-updater", PriceUpdater);

/*
Accordion Item
*/

class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.details = null;
    this.content = null;
  }

  connectedCallback() {
    this.icon = this.querySelector(".accordion__icon");
    this.details = this.querySelector("details");
    this.content = this.querySelector(".content");
    this.details.addEventListener("click", (e) => {
      e.preventDefault();
      this.animateHeight();
    });
  }

  animateHeight() {
    if (this.details.open) {
      if (this.icon) {
        this.icon.style.transform = "rotate(0deg)";
      }
      this.content.style.maxHeight = "0px";
      setTimeout(() => {
        this.details.open = false;
      }, 300);
    } else {
      if (this.icon) {
        this.icon.style.transform = "rotate(135deg)";
      }
      this.details.open = true;
      this.content.style.maxHeight = this.content.scrollHeight + "px";
    }
  }
}

customElements.define("accordion-item", AccordionItem);
